import axios from 'axios';
import config from 'config';
import { setupRequestInterceptors } from './interceptors';

const instance = axios.create({ baseURL: `${config.API_BASE_URL}/legacy` });
const request = setupRequestInterceptors(instance);

const api = {
  searchLegacyFamilyEmail: async (email) => {
    const { data } = await request.get('/family/applications/search', {
      params: { email: String(email || '').toLowerCase() },
    });
    return data;
  },
  getProviderImportStatus: async (applicationId) => {
    const { data } = await request.get(`/providers/applications/${applicationId}/import-status`);
    return data;
  },
  importProviderApplication: async (applicationId, skipDupeCheck = false) => {
    const { data } = await request.post('/providers/applications/import', { applicationId, skipDupeCheck });
    return data;
  },
  getChecklistItems: async (appId) => {
    const { data } = await request.get(`/family/applications/${appId}/checklist/items`);
    return data;
  },
  getChecklistMessages: async (appId) => {
    const { data } = await request.get(`/family/applications/${appId}/checklist/messages`);
    return data;
  },
  uploadAdditionalItem: async (appId, file, note) => {
    let formData = new FormData();
    formData.append('document', file);
    formData.append('note', note);

    const { data } = await request.post(`/family/applications/${appId}/checklist/upload`, formData);
    return data;
  },
  submitChecklistItem: async ({ appId, itemId, file, note }) => {
    const formData = new FormData();
    if (file) {
      formData.append('document', file);
    }
    if (note) {
      formData.append('note', note);
    }
    const { data } = await request.post(`/family/applications/${appId}/checklist/items/${itemId}`, formData);
    return data;
  },
  getChecklistItemHistory: async (appId, itemId) => {
    const { data } = await request.get(`/family/applications/${appId}/checklist/items/${itemId}/history`);
    return data;
  },
  getAdditionalItemsHistory: async (appId) => {
    const { data } = await request.get(`/family/applications/${appId}/checklist/upload/history`);
    return data;
  },
  getChecklistStatus: async (appId) => {
    const { data } = await request.get(`/family/applications/${appId}/checklist/status`);
    return data;
  },
};
export { request };
export default api;
